import { styled } from "@mui/material";
import { Link } from "react-router-dom";

export default styled(Link)`
  color: black;
  text-decoration: none;
`;
